






import { SparePartRequestRefState } from "@/models/interface/sparepart-request";
import Vue from "vue";

export default Vue.extend({
  name: "SparePartRequestFormRef",
  props: {
    data: Object as () => SparePartRequestRefState,
  },
});
